import LoadingOverlay from "~/components/reusable/LoadingOverlay"
import { useAuth0 } from "@auth0/auth0-react"
import CustomerSuccessPage from "~/components/customer-success/CustomerSuccessPage"
import { createFileRoute } from "@tanstack/react-router"
import { OverviewPage } from "~/components/design-system/pages"

export const Route = createFileRoute("/_auth/internal/customer-success/_layout/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { user, isAuthenticated, isLoading } = useAuth0()

  if (!user && isLoading) {
    return <LoadingOverlay />
  }

  if (!isAuthenticated) {
    return <div className="bg-subtle p-4">Not authenticated</div>
  }

  return (
    <OverviewPage contentClassName="p-0">
      <CustomerSuccessPage />
    </OverviewPage>
  )
}
